<!-- Añdele una clase que permita scroll -->
<div class="h-full flex flex-column overflow-auto">
  <!-- Content del modal -->
  <div class="flex-1">
    <!-- Header Section - Sin sombra -->
    @if (!procesado) {
    <div class="surface-card border-round-lg mb-4">
      <div
        class="p-4 border-bottom-1 surface-border bg-gradient-to-r from-primary-50 to-primary-100"
      >
        <div class="flex align-items-center gap-3">
          <div
            class="w-3rem h-3rem bg-primary border-round flex align-items-center justify-content-center shadow-2 header-icon-container"
          >
            <i class="pi pi-upload text-white text-xl"></i>
          </div>
          <div class="flex-grow-1">
            <h2 class="m-0 font-bold text-xl text-900 header-title">
              Carga Masiva de Productos
            </h2>
            <p class="m-0 mt-1 text-sm text-600 font-medium">
              Agregando productos a:
              <span class="font-semibold text-primary"
                >"{{ lista.name }}"</span
              >
            </p>
          </div>
        </div>
      </div>
      <!-- Contenido principal -->
      <div class="p-4">
        <!-- Instrucciones simples y limpias -->
        <div class="mb-4 p-4 surface-50 border-round border-1 border-200">
          <div class="flex align-items-start gap-3">
            <div
              class="w-2rem h-2rem border-circle bg-primary flex align-items-center justify-content-center flex-shrink-0 mt-1"
            >
              <i class="pi pi-info-circle text-white text-sm"></i>
            </div>
            <div class="flex-grow-1">
              <h5 class="m-0 text-900 font-semibold mb-3">
                Instrucciones de carga
              </h5>
              <ol class="m-0 pl-3 text-sm text-600 line-height-3">
                <li class="mb-2">
                  Descarga la plantilla Excel desde el botón de abajo
                </li>
                <li class="mb-2">
                  Completa la columna "SKU" con los códigos de tus productos
                </li>
                <li>
                  Guarda el archivo y súbelo usando el selector de archivos
                </li>
              </ol>
            </div>
          </div>
        </div>
        <!-- Pasos en grid - similar al componente padre -->
        <div class="grid mt-0 mb-4" style="row-gap: 1.5rem">
          <!-- Paso 1: Descargar plantilla -->
          <div class="col-12 py-0">
            <div
              class="surface-card border-round-lg p-4 border-1 border-200 h-full"
            >
              <div class="flex align-items-start gap-3">
                <div
                  class="w-2rem h-2rem bg-green-500 text-white border-circle flex align-items-center justify-content-center font-bold text-sm flex-shrink-0"
                >
                  1
                </div>
                <div class="flex-grow-1">
                  <h6 class="m-0 font-semibold text-900 mb-2">
                    Descargar plantilla Excel
                  </h6>
                  <p class="text-600 text-sm mb-3 line-height-3">
                    Utiliza nuestra plantilla predefinida para asegurar el
                    formato correcto de tu archivo.
                  </p>
                  <div class="file-upload-modern">
                    <p-button
                      label="Descargar plantilla"
                      icon="pi pi-download"
                      styleClass="w-full file-upload-button-style"
                      (click)="downloadTemplate()"
                    >
                    </p-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Paso 2: Selección de archivo -->
          <div class="col-12 py-0">
            <div
              class="surface-card border-round-lg p-4 border-1 border-200 h-full"
            >
              <div class="flex align-items-start gap-3">
                <div
                  class="w-2rem h-2rem bg-orange-500 text-white border-circle flex align-items-center justify-content-center font-bold text-sm flex-shrink-0"
                >
                  2
                </div>
                <div class="flex-grow-1">
                  <h6 class="m-0 font-semibold text-900 mb-2">
                    Seleccionar archivo
                  </h6>
                  <!-- Estado sin archivo -->
                  @if (!file) {
                  <div>
                    <p class="text-600 text-sm mb-3 line-height-3">
                      Sube tu archivo Excel completado (.xlsx, .xls, .csv)
                    </p>
                    <div class="file-upload-modern">
                      <!-- Input file oculto -->
                      <input
                        #fileInput
                        type="file"
                        class="file-input-hidden"
                        accept=".xlsx,.xls,.csv"
                        (change)="onFileChange($event)"
                        [disabled]="procesandoExcel"
                        style="display: none"
                      />
                      <!-- Botón de PrimeNG que dispara el input -->
                      <p-button
                        label="Seleccionar archivo"
                        icon="pi pi-cloud-upload"
                        styleClass="w-full file-upload-button-style"
                        (click)="fileInput.click()"
                        [disabled]="procesandoExcel"
                      >
                      </p-button>
                    </div>
                  </div>
                  }
                  <!-- Estado con archivo seleccionado -->
                  @if (file) {
                  <div>
                    <p class="text-600 text-sm mb-3 line-height-3">
                      Archivo seleccionado correctamente
                    </p>
                    <div
                      class="flex align-items-center gap-3 p-3 bg-green-50 border-round border-1 border-green-200"
                    >
                      <div
                        class="w-2-5rem h-2-5rem bg-green-500 border-round flex align-items-center justify-content-center flex-shrink-0"
                      >
                        <i class="pi pi-file-excel text-white text-lg"></i>
                      </div>
                      <div class="flex-grow-1 min-w-0">
                        <p class="m-0 font-semibold text-green-900 text-sm">
                          {{ file.name }}
                        </p>
                        <p class="m-0 text-xs text-green-700 mt-1">
                          {{ (file.size / 1024 / 1024).toFixed(2) }} MB • Listo
                          para procesar
                        </p>
                      </div>
                      <p-button
                        icon="pi pi-times"
                        severity="danger"
                        styleClass="p-button-rounded p-button-text p-button-sm"
                        (click)="removeFile()"
                        [disabled]="procesandoExcel"
                        pTooltip="Remover archivo"
                      >
                      </p-button>
                    </div>
                  </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Resumen antes de procesar - header con mejor contraste -->
        @if (canProcess()) {
        <div class="mb-3">
          <div
            class="bg-white border-round-xl shadow-3 overflow-hidden"
            style="border: 2px solid #10b981"
          >
            <!-- Header con fondo sólido para mejor contraste -->
            <div class="bg-primary px-4 py-2 text-white">
              <div class="flex align-items-center">
                <div class="flex align-items-center gap-2">
                  <div
                    class="w-2rem h-2rem bg-white bg-opacity-30 border-round flex align-items-center justify-content-center"
                  >
                    <i class="pi pi-check text-primary text-sm font-bold"></i>
                  </div>
                  <div>
                    <h4 class="m-0 font-bold text-white text-sm">
                      ¡Perfecto! Todo está listo
                    </h4>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-4 bg-gray-50">
              <div class="grid">
                <div class="col-12 md:col-6">
                  <div
                    class="flex align-items-center gap-3 p-3 bg-white border-round-lg border-1 border-green-200"
                  >
                    <div
                      class="w-2-5rem h-2-5rem bg-green-100 border-round-lg flex align-items-center justify-content-center"
                    >
                      <i class="pi pi-file-excel text-green-600 text-lg"></i>
                    </div>
                    <div class="flex-grow-1">
                      <p class="m-0 font-semibold text-900 text-sm mb-1">
                        Archivo cargado
                      </p>
                      <p class="m-0 text-xs text-600 line-height-3">
                        {{ file?.name }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-12 md:col-6">
                  <div
                    class="flex align-items-center gap-3 p-3 bg-white border-round-lg border-1 border-blue-200"
                  >
                    <div
                      class="w-2-5rem h-2-5rem bg-blue-100 border-round-lg flex align-items-center justify-content-center"
                    >
                      <i class="pi pi-list text-blue-600 text-lg"></i>
                    </div>
                    <div class="flex-grow-1">
                      <p class="m-0 font-semibold text-900 text-sm mb-1">
                        Lista destino
                      </p>
                      <p class="m-0 text-xs text-600 line-height-3">
                        {{ lista.name }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="mt-3 p-3 bg-gradient-to-r from-blue-50 to-purple-50 border-round-lg border-1 border-blue-200"
              >
                <div
                  class="flex align-items-center justify-content-center gap-2"
                >
                  <i class="pi pi-bolt text-blue-600"></i>
                  <span class="text-sm font-medium text-blue-900"
                    >Procesamiento automático en curso una vez que hagas clic
                    en "Procesar"</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        }
      </div>
    </div>
    }

    <!-- Estado de procesamiento - Sin sombra -->
    @if (procesandoExcel) {
    <div class="surface-card border-round-lg overflow-hidden mb-3">
      <div class="p-6 text-center">
        <div class="mb-4">
          <p-progressSpinner
            strokeWidth="3"
            animationDuration="1s"
            [style]="{ width: '60px', height: '60px' }"
          ></p-progressSpinner>
        </div>
        <h4 class="mt-4 mb-2 text-900 font-bold">Procesando archivo</h4>
        <p class="text-600 m-0 mb-4 text-lg">
          Validando SKUs y agregando productos a la lista
        </p>
        <!-- Indicadores de progreso mejorados -->
        <div class="flex justify-content-center gap-6 mt-4">
          <div class="text-center">
            <div
              class="w-3rem h-3rem bg-primary border-circle flex align-items-center justify-content-center mb-2 mx-auto shadow-2"
            >
              <i class="pi pi-file-excel text-white"></i>
            </div>
            <p class="text-xs text-600 m-0 font-medium">Leyendo archivo</p>
          </div>
          <div class="text-center">
            <div
              class="w-3rem h-3rem bg-orange-500 border-circle flex align-items-center justify-content-center mb-2 mx-auto shadow-2"
            >
              <i class="pi pi-search text-white"></i>
            </div>
            <p class="text-xs text-600 m-0 font-medium">Validando SKUs</p>
          </div>
          <div class="text-center">
            <div
              class="w-3rem h-3rem bg-green-500 border-circle flex align-items-center justify-content-center mb-2 mx-auto shadow-2"
            >
              <i class="pi pi-plus text-white"></i>
            </div>
            <p class="text-xs text-600 m-0 font-medium">Agregando productos</p>
          </div>
        </div>
      </div>
    </div>
    }

    <!-- Resultados Section - Sin sombra -->
    @if (procesado) {
    <div class="surface-card border-round-lg overflow-hidden mb-3">
      <div
        class="p-4 border-bottom-1 surface-border bg-gradient-to-r from-green-50 to-blue-50"
      >
        <div class="flex align-items-center gap-3">
          <div
            class="w-3rem h-3rem bg-gradient-to-br from-green-500 to-blue-500 border-round flex align-items-center justify-content-center shadow-2 header-icon-container"
          >
            <i class="pi pi-check-circle text-white text-xl"></i>
          </div>
          <div class="flex-grow-1">
            <h2 class="m-0 font-bold text-xl text-900 header-title">
              Procesamiento completado
            </h2>
            <p class="m-0 mt-1 text-sm text-600 font-medium">
              {{ productosCargados.length }} productos agregados,
              {{ productosNoCargados.length }} no encontrados
            </p>
          </div>
        </div>
      </div>
      <div class="p-4">
        <!-- Productos agregados - diseño simplificado como en la imagen -->
        @if (productosCargados.length) {
        <div class="mb-4">
          <div
            class="surface-card border-round border-1 border-green-200 overflow-hidden"
          >
            <!-- Header minimalista -->
            <div class="px-3 py-2 bg-green-50 flex align-items-center gap-2">
              <i class="pi pi-check text-green-600 text-sm"></i>
              <span class="font-bold text-green-800 text-sm"
                >{{ productosCargados.length }} productos agregados</span
              >
            </div>
            <!-- Lista simplificada -->
            <div
              class="productos-agregados-lista"
              style="max-height: 200px; overflow-y: auto; background: white"
            >
              @for (producto of productosCargados; track producto.sku; let i =
              $index) {
              <div class="px-3 py-2 flex align-items-center gap-3 bg-white">
                <!-- Número secuencial -->
                <span
                  class="bg-green-100 text-green-800 font-bold text-xs px-2 py-1 border-round flex-shrink-0"
                >
                  {{ i + 1 }}
                </span>
                <!-- Imagen del producto -->
                <img
                  [src]="producto.preview"
                  [alt]="producto.name"
                  class="border-round border-1 border-300 flex-shrink-0"
                  style="width: 32px; height: 32px; object-fit: cover"
                />
                <!-- Información del producto -->
                <div class="flex-grow-1 min-w-0">
                  <p
                    class="m-0 font-medium text-sm text-900 line-height-3"
                    style="
                      display: -webkit-box;
                      -webkit-line-clamp: 1;
                      line-clamp: 1;
                      -webkit-box-orient: vertical;
                      overflow: hidden;
                    "
                  >
                    {{ producto.name }}
                  </p>
                  <p class="m-0 text-xs text-green-700 font-medium">
                    {{ producto.sku }}
                  </p>
                </div>
                <!-- Icono de éxito -->
                <i class="pi pi-check text-green-500 flex-shrink-0"></i>
              </div>
              }
            </div>
          </div>
        </div>
        }
        <!-- Productos no encontrados - diseño simplificado -->
        @if (productosNoCargados.length) {
        <div class="mb-4">
          <div
            class="surface-card border-round border-1 border-orange-200 overflow-hidden"
          >
            <!-- Header minimalista -->
            <div class="px-3 py-2 bg-orange-50 flex align-items-center gap-2">
              <i
                class="pi pi-exclamation-triangle text-orange-600 text-sm"
              ></i>
              <span class="font-bold text-orange-800 text-sm"
                >{{ productosNoCargados.length }} SKUs no encontrados</span
              >
            </div>
            <!-- Lista simplificada de errores -->
            <div
              class="productos-no-encontrados-lista"
              style="max-height: 150px; overflow-y: auto; background: white"
            >
              @for (producto of productosNoCargados; track $index) {
              <div class="px-3 py-2 flex align-items-center gap-3 bg-white">
                <!-- Número de línea -->
                <span
                  class="bg-orange-100 text-orange-800 font-bold text-xs px-2 py-1 border-round flex-shrink-0"
                >
                  L{{ producto.line }}
                </span>
                <!-- Icono de error -->
                <div
                  class="w-2rem h-2rem border-round bg-orange-100 flex align-items-center justify-content-center flex-shrink-0"
                >
                  <i
                    class="pi pi-exclamation-triangle text-orange-500 text-xs"
                  ></i>
                </div>
                <!-- Información del error -->
                <div class="flex-grow-1 min-w-0">
                  <p class="m-0 font-medium text-sm text-900">
                    SKU: {{ producto.sku }}
                  </p>
                  <p class="m-0 text-xs text-orange-600">No encontrado</p>
                </div>
                <!-- Icono de fallo -->
                <i class="pi pi-times text-orange-500 flex-shrink-0"></i>
              </div>
              }
            </div>
          </div>
        </div>
        }
        <!-- Sugerencias solo si hay errores -->
        @if (productosNoCargados.length) {
        <div
          class="surface-50 border-round-lg p-4 border-left-3 border-yellow-500"
        >
          <div class="flex align-items-start gap-3">
            <div
              class="w-2rem h-2rem border-circle bg-yellow-100 flex align-items-center justify-content-center flex-shrink-0 mt-1"
            >
              <i class="pi pi-lightbulb text-yellow-600 text-sm"></i>
            </div>
            <div>
              <h6 class="m-0 text-900 font-semibold mb-2">
                Sugerencias para mejorar
              </h6>
              <div class="text-sm text-600 line-height-3">
                <p class="m-0">
                  • Verifica que los SKUs estén escritos exactamente como
                  aparecen en el catálogo<br />
                  • Asegúrate de que los productos no hayan sido
                  descontinuados<br />
                  • Revisa que no haya espacios en blanco al inicio o final de
                  los SKUs
                </p>
              </div>
            </div>
          </div>
        </div>
        }
      </div>
    </div>
    }
  </div>

  <!-- Footer - consistente con el padre -->
  <div class="border-top-1 surface-border bg-white p-4 flex-shrink-0">
    <div class="flex justify-content-between align-items-center">
      <!-- Información adicional -->
      @if (procesado) {
      <div class="text-sm text-600">
        <i class="pi pi-check-circle text-green-600 mr-2"></i>
        <span class="font-medium">Proceso completado exitosamente</span>
      </div>
      }

      <!-- Botones -->
      <div class="flex gap-1">
        @if (procesado) {
        <p-button
          label="Finalizar"
          icon="pi pi-check"
          styleClass="font-medium"
          (click)="close(true)"
        >
        </p-button>
        } @else {

        <p-button
          label="Cancelar"
          icon="pi pi-times"
          severity="secondary"
          (click)="close(false)"
          [disabled]="procesandoExcel"
        >
        </p-button>

        <p-button
          label="Procesar Archivo"
          icon="pi pi-cog"
          styleClass="font-medium hidden md:block"
          [loading]="procesandoExcel"
          loadingIcon="pi pi-spin pi-spinner"
          [disabled]="!canProcess()"
          (click)="procesarArchivo()"
        >
        </p-button>

        <p-button
          label="Procesar"
          icon="pi pi-cog"
          styleClass="font-medium block md:hidden"
          [loading]="procesandoExcel"
          loadingIcon="pi pi-spin pi-spinner"
          [disabled]="!canProcess()"
          (click)="procesarArchivo()"
        >
        </p-button>

        }
      </div>
    </div>
  </div>
</div>
